import {getAccessToken, refreshAccessToken, requestNewTokens} from "./tokenService";

export async function authFetch(url: string, options: RequestInit = {}) {
    let token = getAccessToken();

    // 1) Wenn kein Token vorhanden → Anonymous-Token holen
    if (!token) {
        await requestNewTokens();
        token = getAccessToken();
    }

    let res = await fetch(`${process.env.REACT_APP_BACKEND_URL}${url}`, {
        ...options,
        headers: {
            ...options.headers,
            Authorization: `Bearer ${token}`
        }
    });

    // 2) WICHTIG: 404 sofort zurückgeben, ohne Token-Refresh
    if (res.status === 404) {
        return res;
    }

    // 3) Token abgelaufen → Refresh versuchen
    if (res.status === 401) {
        const refreshed = await refreshAccessToken();

        if (!refreshed) {
            await requestNewTokens();
        }

        token = getAccessToken();

        res = await fetch(`${process.env.REACT_APP_BACKEND_URL}${url}`, {
            ...options,
            headers: {
                ...options.headers,
                Authorization: `Bearer ${token}`
            }
        });
    }

    return res;
}
